export interface ServiceReportsResponse {
    serviceReports: ServiceReport[];
}

export interface ServiceReport {
    equipmentName: string;
    equipmentNumber: string;
    equipmentAlias?: string;
    date: string;
    technicianName: string;
    reportDownload: string;
}
